import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import { WorkOrderService } from "../../../services/index";
import { ActualCuttingService } from "../../../services/index";

@Component({
  selector: "addEditPurchaseOrder",
  templateUrl: "./addEditStoreFusing.html",
})
export class AddEditStoreFusing {
  row: any;
  data: any;
  designdata: any = {};
  wodata: any = {
    shirt_design_no: "",
    party_code: "",
    party_name: "",
    totalrate: 0,
    fullrate: 0,
    halfrate: 0,
    f36_ratio: 0,
    f38_ratio: 0,
    f40_ratio: 0,
    f42_ratio: 0,
    f44_ratio: 0,
    f46_ratio: 0,
    h36_ratio: 0,
    h38_ratio: 0,
    h40_ratio: 0,
    h42_ratio: 0,
    h44_ratio: 0,
    h46_ratio: 0,
    tot_full_ratio: 0,
    tot_half_ratio: 0,
    // issuepart_1: []
  };
  qualityList: any;
  typeList: any;
  colorList: any;
  fabtype: any;
  codeList: any;
  stockdata: any[];
  matchstockdata: any[];

  widthList: any[];
  multiFablist = [];
  multiFablist1 = [];
  designnoList: any[];
  tempColor = [];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  shadeList: any;
  matchList: any;
  matchDesList = [];
  matchColorList: any;
  matchDesColorList = [];
  matchConsList: any;
  matchDesConsList = [];
  issuedPart = [];
  issuePartList = [];
  designList = [
    {
      design_no: "",
      shade: "",
      color: "",
      meter: 0,
      mtr: 0,
      fs_tot_cons: 0,
      hs_tot_cons: 0,
      fs_tot_pcs: 0,
      hs_tot_pcs: 0,
      ftot: 0,
      htot: 0,
      fbalmtrs: 0,
      hbalmtrs: 0,
      totmtrs: 0,
    },
  ];

  param:any;
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this.getIssuePartList();
    this._params = val;
    this.mode = val["mode"];
    this.param = val["param"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);
    this.wodata = designdata;
    if (this.mode == "Edit" || this.mode == "Cancel") {
      this.calcFullCons();
      this.getDesignList(this.wodata.ac_id);
    } else if (this.mode == "View") {
      this.wodata.issuepart_1 = this.wodata.issuepart_1.split(',').filter(x => x!='')
      this.wodata = designdata;
      this.wodata.fusing_issue_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      if(this.param == 'store_to_collar'){
        this.wodata.collar_issue_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      }
      this.calcFullCons();
      this.getDesignList1(this.wodata.ac_id);
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private woservice: WorkOrderService,
    private acService: ActualCuttingService
  ) { }
  ngOnInit() {
    this.tableScroll();
    if (this.mode == "Add" || this.mode == "view") {
      this.getIssuePartList();
      this.wodata.fusing_issue_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      if(this.param == 'store_to_collar'){
        this.wodata.collar_issue_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      }
      if (this.mode == "Add") {
        this.getIssuedPart();
        this.getIssuePartList();
        this.wodata.f36_ratio = 0;
        (this.wodata.f38_ratio = 0),
          (this.wodata.f40_ratio = 0),
          (this.wodata.f42_ratio = 0),
          (this.wodata.f44_ratio = 0),
          (this.wodata.f46_ratio = 0),
          (this.wodata.h36_ratio = 0),
          (this.wodata.h38_ratio = 0),
          (this.wodata.h40_ratio = 0),
          (this.wodata.h42_ratio = 0),
          (this.wodata.h44_ratio = 0),
          (this.wodata.h46_ratio = 0),
          (this.wodata.tot_full_ratio = 0),
          (this.wodata.tot_half_ratio = 0);
      }
    }
  }

  tableScroll() {
    $(".workorderbody").height(window.innerHeight - 400);
    $(".workorderbody").width(window.innerWidth - 30);
  }

  ngAfterViewInit() {
    if (this.mode == "Add") {
      setTimeout(() => {
        $("#shirtno").focus();
      }, 100);
    } else {
      setTimeout(() => {
        $("#f36-1").focus();
      }, 100);
    }
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (nextEl == "f36-1") {
      $("#" + nextEl).select();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }
  onGoToMatchNextFld($event, fld, ind) {
    let nxtInd = ind;
    if (fld == 'addrow') {
    }
    else {
      setTimeout(() => {
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      shade = this.designList[ind]["shade"],
      meter = this.designList[ind]["meter"],
      fper = this.designList[ind]["fper"],
      hper = this.designList[ind]["hper"],
      balmtrs = this.designList[ind].fbalmtrs,
      totmtrs = this.designList[ind]["totmtrs"];

    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "f36") {
      this.onSelectShade(this.designList[ind]["shade"], ind);
      $("#" + "f36" + "-" + nxtInd).focus();
      return false;
    }
    if (fld == "shade" && nxtRow.length == 0) {
      let len = this.designList.length;
      let shade = this.designList[len - 1]["shade"];

      nxtInd = nxtInd + 1;
      $("#" + "shade" + "-" + nxtInd).focus();

      if (shade != "" && nxtInd == len) {
        this.designList.push({
          design_no: "",
          shade: "",
          color: "",
          meter: 0,
          fs_tot_cons: 0,
          hs_tot_cons: 0,
          fs_tot_pcs: 0,
          hs_tot_pcs: 0,

          ftot: 0,
          mtr: 0,
          htot: 0,
          fbalmtrs: 0,
          hbalmtrs: 0,
          totmtrs: 0,
        });

        $("#" + "shade" + "-" + nxtInd).focus();
      } else if (shade == "" && nxtInd == len) {
        let a = nxtInd - 1;
        $("#" + "shade" + "-" + a).focus();
      } else {
        $("#" + "shade" + "-" + nxtInd).focus();
        return false;
      }
    } else {
      setTimeout(() => {
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }
  
  getIssuedPart() {
    let params = {
      start: 0,
      limit: 100,
      types : this.param
    };
    this.acService.getIssuedPart(params).then((res: any) => {
      let partialIssuedPart = [];

      this.issuedPart = res;
      // console.log("this.issuedPart",this.issuedPart);
    });
  }
  getIssuePartList() {
    let params = {
      start: 0,
      limit: 100,
    };
    this.acService.getIssuePartList(params).then((res: any) => {
      let partialIssuePartList = [];

      this.issuePartList = res;
      // console.log("this.issuePartList",this.issuePartList);
    });
  }

  getDesignList(ac_id) {
    let params = {
      ac_id: ac_id,
    };
    if (this.mode == "Cancel") {
      params["mode"] = this.mode;
    }
    this.acService.getEditStoreFusingDetails(params).then((res: any) => {
      for (let i = 0; i < res.data.length; i++) {
        this.designList[i] = res.data[i];
        this.designList[i].color = res.data[i].color;
      }
    });
  }
  getworkOrder(wono) {
      let params = {
        wo_no: wono,
        issuepart_1: wono,
        issuepart_2: wono,
      };

      let that = this;
      that.acService.getStoreFusingDetails(params).then((res: any) => {
            this.designList = res.data;
            this.wodata.ac_id = res.ac_id;
            this.calcGrandTotal();
      });
  }
  calcGrandTotal() {
    let nan = function (no) {
      if (no == "" || no == null) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    },
      ret_mtr = 0,
      retbal_mtr = 0,
      meter = 0,
      f36_tot = 0,
      f38_tot = 0,
      f40_tot = 0,
      f42_tot = 0,
      f44_tot = 0,
      f46_tot = 0,
      h36_tot = 0,
      h38_tot = 0,
      h40_tot = 0,
      h42_tot = 0,
      h44_tot = 0,
      h46_tot = 0;
    for (let i = 0; i < this.designList.length; i++) {
      let des = this.designList[i];
      meter = nan(des["meter"]);
      ret_mtr = nan(des["ret_mtr"]);
      retbal_mtr = nan(des["retbal_mtr"]);
      f36_tot += nan(des["ac_f36"]);
      f38_tot += nan(des["ac_f38"]);
      f40_tot += nan(des["ac_f40"]);
      f42_tot += nan(des["ac_f42"]);
      f44_tot += nan(des["ac_f44"]);
      f46_tot += nan(des["ac_f46"]);
      h36_tot += nan(des["ac_h36"]);
      h38_tot += nan(des["ac_h38"]);
      h40_tot += nan(des["ac_h40"]);
      h42_tot += nan(des["ac_h42"]);
      h44_tot += nan(des["ac_h44"]);
      h46_tot += nan(des["ac_h46"]);
    }
    this.wodata["meter"] = meter;
    this.wodata["ret_mtr"] = ret_mtr;
    this.wodata["retbal_mtr"] = retbal_mtr;
    this.wodata["ac_f36_tot"] = f36_tot;
    this.wodata["ac_f38_tot"] = f38_tot;
    this.wodata["ac_f40_tot"] = f40_tot;
    this.wodata["ac_f42_tot"] = f42_tot;
    this.wodata["ac_f44_tot"] = f44_tot;
    this.wodata["ac_f46_tot"] = f46_tot;
    this.wodata["ac_h36_tot"] = h36_tot;
    this.wodata["ac_h38_tot"] = h38_tot;
    this.wodata["ac_h40_tot"] = h40_tot;
    this.wodata["ac_h42_tot"] = h42_tot;
    this.wodata["ac_h44_tot"] = h44_tot;
    this.wodata["ac_h46_tot"] = h46_tot;

    this.wodata["ac_fs_total"] =
      nan(f36_tot) +
      nan(f38_tot) +
      nan(f40_tot) +
      nan(f42_tot) +
      nan(f44_tot) +
      nan(f46_tot);
    this.wodata["ac_hs_total"] =
      nan(h36_tot) +
      nan(h38_tot) +
      nan(h40_tot) +
      nan(h42_tot) +
      nan(h44_tot) +
      nan(h46_tot);

    this.wodata["ac_fh36_tot"] =
      nan(this.wodata["ac_f36_tot"]) + nan(this.wodata["ac_h36_tot"]);
    this.wodata["ac_fh38_tot"] =
      nan(this.wodata["ac_f38_tot"]) + nan(this.wodata["ac_h38_tot"]);
    this.wodata["ac_fh40_tot"] =
      nan(this.wodata["ac_f40_tot"]) + nan(this.wodata["ac_h40_tot"]);
    this.wodata["ac_fh42_tot"] =
      nan(this.wodata["ac_f42_tot"]) + nan(this.wodata["ac_h42_tot"]);
    this.wodata["ac_fh44_tot"] =
      nan(this.wodata["ac_f44_tot"]) + nan(this.wodata["ac_h44_tot"]);
    this.wodata["ac_fh46_tot"] =
      nan(this.wodata["ac_f46_tot"]) + nan(this.wodata["ac_h46_tot"]);
    this.wodata["ac_tot_pcs"] =
      nan(this.wodata["ac_fs_total"]) + nan(this.wodata["ac_hs_total"]);
    this.calcDiff();
  }
  calcDiff() {
    let nan = function (no) {
      if (no == "" || no == null) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    },
      ac_tot_diff = 0;
    for (let i = 0; i < this.designList.length; i++) {
      let des = this.designList[i];
      ac_tot_diff += nan(des["ac_fs_diff"]) + nan(des["ac_hs_diff"]);
    }
    this.wodata["ac_tot_diff"] = ac_tot_diff;
  }

  getDesignList1(ac_id) {
    let params = {
      ac_id: ac_id,
    };
    this.acService.getEditStoreFusingDetails(params).then((res: any) => {
      for (let i = 0; i < res.data.length; i++) {
        this.designList[i] = res.data[i];
        this.designList[i].color = res.data[i].color;
      }
    });
  }

  calcFullCons() {
    //totalfullratio
    this.wodata.tot_full_ratio = (
      this.wodata.f36_ratio +
      this.wodata.f38_ratio +
      this.wodata.f40_ratio +
      this.wodata.f42_ratio +
      this.wodata.f44_ratio +
      this.wodata.f46_ratio
    ).toFixed(2);
    //First half formula calculation for full sleeve
    this.wodata.f36_calc = (
      (this.wodata.f36_ratio * 100) /
      this.wodata.tot_full_ratio
    ).toFixed(2);
    this.wodata.f38_calc = (
      (this.wodata.f38_ratio * 100) /
      this.wodata.tot_full_ratio
    ).toFixed(2);
    this.wodata.f40_calc = (
      (this.wodata.f40_ratio * 100) /
      this.wodata.tot_full_ratio
    ).toFixed(2);
    this.wodata.f42_calc = (
      (this.wodata.f42_ratio * 100) /
      this.wodata.tot_full_ratio
    ).toFixed(2);
    this.wodata.f44_calc = (
      (this.wodata.f44_ratio * 100) /
      this.wodata.tot_full_ratio
    ).toFixed(2);
    this.wodata.f46_calc = (
      (this.wodata.f46_ratio * 100) /
      this.wodata.tot_full_ratio
    ).toFixed(2);
    //totalhalfratio
    this.wodata.tot_half_ratio = (
      this.wodata.h36_ratio +
      this.wodata.h38_ratio +
      this.wodata.h40_ratio +
      this.wodata.h42_ratio +
      this.wodata.h44_ratio +
      this.wodata.h46_ratio
    ).toFixed(2);
    //First half formula calculation for half sleeve
    this.wodata.h36_calc =
      this.wodata.tot_half_ratio && this.wodata.h36_ratio
        ? ((this.wodata.h36_ratio * 100) / this.wodata.tot_half_ratio).toFixed(
          2
        )
        : 0;
    this.wodata.h38_calc =
      this.wodata.tot_half_ratio && this.wodata.h38_ratio
        ? ((this.wodata.h38_ratio * 100) / this.wodata.tot_half_ratio).toFixed(
          2
        )
        : 0;
    this.wodata.h40_calc =
      this.wodata.tot_half_ratio && this.wodata.h40_ratio
        ? ((this.wodata.h40_ratio * 100) / this.wodata.tot_half_ratio).toFixed(
          2
        )
        : 0;
    this.wodata.h42_calc =
      this.wodata.tot_half_ratio && this.wodata.h42_ratio
        ? ((this.wodata.h42_ratio * 100) / this.wodata.tot_half_ratio).toFixed(
          2
        )
        : 0;
    this.wodata.h44_calc =
      this.wodata.tot_half_ratio && this.wodata.h44_ratio
        ? ((this.wodata.h44_ratio * 100) / this.wodata.tot_half_ratio).toFixed(
          2
        )
        : 0;
    this.wodata.h46_calc =
      this.wodata.tot_half_ratio && this.wodata.h46_ratio
        ? ((this.wodata.h46_ratio * 100) / this.wodata.tot_half_ratio).toFixed(
          2
        )
        : 0;
    //total of first half formulat values
    this.wodata.tot_full_calc = Math.round(
      parseFloat(this.wodata.f36_calc) +
      parseFloat(this.wodata.f38_calc) +
      parseFloat(this.wodata.f40_calc) +
      parseFloat(this.wodata.f42_calc) +
      parseFloat(this.wodata.f44_calc) +
      parseFloat(this.wodata.f46_calc)
    ).toFixed(2);
    this.wodata.tot_half_calc = Math.round(
      parseFloat(this.wodata.h36_calc) +
      parseFloat(this.wodata.h38_calc) +
      parseFloat(this.wodata.h40_calc) +
      parseFloat(this.wodata.h42_calc) +
      parseFloat(this.wodata.h44_calc) +
      parseFloat(this.wodata.h46_calc)
    ).toFixed(2);
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.designList.length > 1) {
          that.designList.splice(ind, 1);

          if ($("#" + fld + "-" + (ind - 1)).length > 0) {
            $("#" + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + fld + "-" + (ind + 1)).length > 0) {
            $("#" + fld + "-" + (ind + 1)).focus();
          }
        }
        that.calcTotal();
      },
      function (dismiss) { }
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }
  getAuto() {
    this.designList.forEach((arr) => { 
      if (this.mode == "Add") {
        this.oncheckemptyrow();
      } else {
        this.oncheckemptyrow();
      } 
    });
  }

  onSelectShade(shade, ind) {
    let color = this.shadeList.filter((o) => o.shade == shade)
    this.designList[ind].color = color[0].color;
    this.stockdata = [];
    let params = {
      fab_design_no: this.wodata.fab_design,
      shirt_design_no: this.wodata.shirt_design_no,
      color: shade,
      fab_type: this.fabtype

    };
    let that = this;
    that.woservice.getStock(params).then((res: any) => {
      if (res.data.length > 0) {
        this.stockdata = res.data;
      } else {
        this.designList[ind]["mtr"] = 0;
        this.designList[ind]["fs_tot_cons"] = 0;
        this.designList[ind]["hs_tot_cons"] = 0;
        this.designList[ind]["fs_tot_pcs"] = 0;
        this.designList[ind]["hs_tot_pcs"] = 0;
        this.designList[ind]["f36"] = 0;
        this.designList[ind]["f38"] = 0;
        this.designList[ind]["f40"] = 0;
        this.designList[ind]["f42"] = 0;
        this.designList[ind]["f44"] = 0;
        this.designList[ind]["f46"] = 0;
        this.designList[ind]["h36"] = 0;
        this.designList[ind]["h38"] = 0;
        this.designList[ind]["h40"] = 0;
        this.designList[ind]["h42"] = 0;
        this.designList[ind]["h44"] = 0;
        this.designList[ind]["h46"] = 0;
        this.calcBalMtrs(ind);
      }
    });
  }

  calcBalMtrs(ind) {
    let nan = function (no) {
      if (no == "" || no == null) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    };
    //ftotalpcs
    this.designList[ind]["ftot"] =
      nan(this.designList[ind]["f36"]) +
      nan(this.designList[ind]["f38"]) +
      nan(this.designList[ind]["f40"]) +
      nan(this.designList[ind]["f42"]) +
      nan(this.designList[ind]["f44"]) +
      nan(this.designList[ind]["f46"]);

    //htotalpcs
    this.designList[ind]["htot"] =
      nan(this.designList[ind]["h36"]) +
      nan(this.designList[ind]["h38"]) +
      nan(this.designList[ind]["h40"]) +
      nan(this.designList[ind]["h42"]) +
      nan(this.designList[ind]["h44"]) +
      nan(this.designList[ind]["h46"]);

    //balance meters
    this.designList[ind]["fbalmtrs"] =
      nan(this.designList[ind]["mtr"]) -
      nan(this.designList[ind]["ftot"] * this.wodata.wo_full_cons);
    this.designList[ind]["hbalmtrs"] =
      nan(this.designList[ind]["mtr"]) -
      nan(this.designList[ind]["htot"] * this.wodata.wo_half_cons);
    this.designList[ind]["balmtrs"] = nan(
      this.designList[ind]["fbalmtrs"] +
      this.designList[ind]["hbalmtrs"] -
      this.designList[ind]["mtr"]
    ).toFixed(2);

    this.calcTotal();
  }

  calcTotal() {
    let nan = function (no) {
      if (no == "" || no == null) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    },
      fs_tot = 0,
      hs_tot = 0,
      fh36_tot = 0,
      fh38_tot = 0,
      fh40_tot = 0,
      fh42_tot = 0,
      fh44_tot = 0,
      fh46_tot = 0,
      tot_pcs = 0;
    for (let i = 0; i < this.designList.length; i++) {
      const li = this.designList[i];
      fs_tot +=
        nan(li["f36"]) +
        nan(li["f38"]) +
        nan(li["f40"]) +
        nan(li["f42"]) +
        nan(li["f44"]) +
        nan(li["f46"]);
      hs_tot +=
        nan(li["h36"]) +
        nan(li["h38"]) +
        nan(li["h40"]) +
        nan(li["h42"]) +
        nan(li["h44"]) +
        nan(li["h46"]);
      fh36_tot += nan(li["f36"]) + nan(li["h36"]);
      fh38_tot += nan(li["f38"]) + nan(li["h38"]);
      fh40_tot += nan(li["f40"]) + nan(li["h40"]);
      fh42_tot += nan(li["f42"]) + nan(li["h42"]);
      fh44_tot += nan(li["f44"]) + nan(li["h44"]);
      fh46_tot += nan(li["f46"]) + nan(li["h46"]);
      tot_pcs += nan(li["ftot"]) + nan(li["htot"]);
    }
    this.wodata.fs_total = fs_tot;
    this.wodata.hs_total = hs_tot;
    this.wodata.fh36_tot = fh36_tot;
    this.wodata.fh38_tot = fh38_tot;
    this.wodata.fh40_tot = fh40_tot;
    this.wodata.fh42_tot = fh42_tot;
    this.wodata.fh44_tot = fh44_tot;
    this.wodata.fh46_tot = fh46_tot;
    this.wodata.tot_pcs = tot_pcs;
  }

  oncheckemptyrow() {
    if (
      this.wodata.wo_no == undefined 
    ) {
      swal("Make sure that all the details are given!");
    } else {
      let design = this.designList;
      let desList = [];
      for (let i = 0; i < design.length; i++) {
        if (design[i].shade != "") {
          desList.push(design[i]);
        }

        this.designList = desList;
        this.saveStoreFusing();
      }
    }
  }

  saveStoreFusing(): void {
    let params: any = Object.assign({}, this.wodata);
    params["tabevent"] = undefined;
    // params["data"] = JSON.stringify(this.designList);
    params["fusing_issue_date"] = this.datePipe.transform(
      params["fusing_issue_date"],
      "yyyy-MM-dd"
    );
    params['flag'] = this.param;
    if(this.param == 'store_to_collar') {
      params['collar_part'] = this.wodata.collar_part;
      params["collar_issue_date"] = this.datePipe.transform(
        params["collar_issue_date"],
        "yyyy-MM-dd"
      );
    }
    let that = this;
    that.isLoading = true;
    swal({
      title: "Are you sure to save this Work Order?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      $("#save").prop("disabled", true);
      that.isLoading = true;
      that.acService
        .saveStoreFusing(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            let tabObj = {
              action: "CloseTab",
              params: {},
            };
            that.tabUpdateEvent.emit(tabObj);

            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }

}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/storeFusing/addEditStoreFusing.ts